import { render, staticRenderFns } from "./GoodsAddUpdate.vue?vue&type=template&id=1f3045c6&scoped=true"
import script from "./GoodsAddUpdate.vue?vue&type=script&lang=js"
export * from "./GoodsAddUpdate.vue?vue&type=script&lang=js"
import style0 from "./GoodsAddUpdate.vue?vue&type=style&index=0&id=1f3045c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3045c6",
  null
  
)

export default component.exports